/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfrastructureResourcesIssuesFlowWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("InfrastructureResourcesIssuesFlowWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return InfrastructureResourcesIssuesFlowWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<InfrastructureResourcesIssuesFlowWidgetConfiguration>): InfrastructureResourcesIssuesFlowWidgetConfiguration {
        let obj = Object.assign(new InfrastructureResourcesIssuesFlowWidgetConfiguration(), model);
        InfrastructureResourcesIssuesFlowWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfrastructureResourcesIssuesFlowWidgetConfiguration>): InfrastructureResourcesIssuesFlowWidgetConfiguration {
        if (!model) return null;
        return InfrastructureResourcesIssuesFlowWidgetConfiguration.newInstance(<InfrastructureResourcesIssuesFlowWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfrastructureResourcesIssuesFlowWidgetConfiguration) {
        if (!obj) return;

        models.InfrastructureResourcesIssuesFlowWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfrastructureResourcesIssuesFlowWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfrastructureResourcesIssuesFlowWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
